import React, { createContext, useContext, useEffect, useState } from "react";

const LikeContext = createContext();

export const LikeProvider = ({ children }) => {
  const [likedProductIds, setLikedProductIds] = useState(() => {
    const saved = localStorage.getItem("likedProducts");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem("likedProducts", JSON.stringify(likedProductIds));
  }, [likedProductIds]);

  const isLiked = (productId) => likedProductIds.includes(productId);

  const toggleLike = (productId) => {
    setLikedProductIds((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };

  return (
    <LikeContext.Provider value={{ likedProductIds, isLiked, toggleLike }}>
      {children}
    </LikeContext.Provider>
  );
};

export const useLike = () => useContext(LikeContext);
